import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-male-chair-workouts': {
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_wheel_of_fortune_chair_workouts'
					),
			},
		},
	},
]

export default config
